module.exports = __webpack_public_path__ + "img/white-bar-chart-icon.59881190.svg";